(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define('steps-side-menu',["react"], factory);
	else if(typeof exports === 'object')
		exports["SideMenu"] = factory(require("react"));
	else
		root["SideMenu"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SideMenu = __webpack_require__(1);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SideMenu).default;
	  }
	});
	
	var _stepKeys = __webpack_require__(22);
	
	Object.defineProperty(exports, 'stepKeys', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_stepKeys).default;
	  }
	});
	
	var _configure = __webpack_require__(75);
	
	Object.defineProperty(exports, 'configure', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_configure).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SideMenuTitle = __webpack_require__(3);
	
	var _SideMenuTitle2 = _interopRequireDefault(_SideMenuTitle);
	
	var _Close = __webpack_require__(8);
	
	var _Close2 = _interopRequireDefault(_Close);
	
	var _StepsSection = __webpack_require__(11);
	
	var _StepsSection2 = _interopRequireDefault(_StepsSection);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _completeStep = __webpack_require__(54);
	
	var _completeStep2 = _interopRequireDefault(_completeStep);
	
	__webpack_require__(65);
	
	var _Footer = __webpack_require__(67);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _translations = __webpack_require__(70);
	
	var _translations2 = _interopRequireDefault(_translations);
	
	var _initializeTranslations = __webpack_require__(71);
	
	var _initializeTranslations2 = _interopRequireDefault(_initializeTranslations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  isShown: _react.PropTypes.bool,
	  title: _react.PropTypes.string,
	  handleClose: _react.PropTypes.func.isRequired,
	  steps: _react.PropTypes.arrayOf(_react.PropTypes.object),
	  isMac: _react.PropTypes.bool,
	  isWindows: _react.PropTypes.bool,
	  browser: _react.PropTypes.string,
	  track: _react.PropTypes.func,
	  locale: _react.PropTypes.string
	};
	
	var defaultProps = {
	  isShown: true,
	  isMac: false,
	  browser: 'chrome',
	  locale: 'en'
	};
	
	var SideMenu = function (_Component) {
	  _inherits(SideMenu, _Component);
	
	  function SideMenu(props) {
	    _classCallCheck(this, SideMenu);
	
	    var _this = _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this, props));
	
	    (0, _initializeTranslations2.default)({
	      language: _this.props.locale,
	      translations: _translations2.default
	    });
	    return _this;
	  }
	
	  _createClass(SideMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.isShown && !nextProps.isShown) {
	        _completeStep2.default.execute();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ 'side-menu': true, shown: this.props.isShown }) },
	        _react2.default.createElement(_SideMenuTitle2.default, { text: this.props.title }),
	        _react2.default.createElement(_Close2.default, { onClick: this.props.handleClose }),
	        _react2.default.createElement(_StepsSection2.default, {
	          isShown: this.props.isShown,
	          steps: this.props.steps,
	          isMac: this.props.isMac,
	          browser: this.props.browser,
	          track: this.props.track,
	          locale: this.props.locale
	        }),
	        _react2.default.createElement(_Footer2.default, { isWindows: this.props.isWindows })
	      );
	    }
	  }]);
	
	  return SideMenu;
	}(_react.Component);
	
	exports.default = SideMenu;
	
	
	SideMenu.propTypes = propTypes;
	SideMenu.defaultProps = defaultProps;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  text: _react.PropTypes.string
	};
	
	var Title = function Title(_ref) {
	  var text = _ref.text;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'side-menu-title' },
	    text
	  );
	};
	
	Title.propTypes = propTypes;
	
	exports.default = Title;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onClick: _react.PropTypes.func.isRequired
	};
	
	var Close = function Close(_ref) {
	  var onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'button',
	    {
	      id: 'side-menu-close',
	      className: 'btn btn-link close',
	      onClick: onClick
	    },
	    _react2.default.createElement('i', { className: 'togo-icon togo-icon-closes' })
	  );
	};
	
	Close.propTypes = propTypes;
	
	exports.default = Close;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Step = __webpack_require__(12);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _stepKeys = __webpack_require__(22);
	
	var _stepKeys2 = _interopRequireDefault(_stepKeys);
	
	var _PersonalRoomStep = __webpack_require__(23);
	
	var _PersonalRoomStep2 = _interopRequireDefault(_PersonalRoomStep);
	
	var _ScheduleStep = __webpack_require__(42);
	
	var _ScheduleStep2 = _interopRequireDefault(_ScheduleStep);
	
	var _AudioStep = __webpack_require__(45);
	
	var _AudioStep2 = _interopRequireDefault(_AudioStep);
	
	var _TestMeetingStep = __webpack_require__(48);
	
	var _TestMeetingStep2 = _interopRequireDefault(_TestMeetingStep);
	
	var _CalendarStep = __webpack_require__(51);
	
	var _CalendarStep2 = _interopRequireDefault(_CalendarStep);
	
	var _completeStep = __webpack_require__(54);
	
	var _completeStep2 = _interopRequireDefault(_completeStep);
	
	var _indicator = __webpack_require__(55);
	
	var _indicator2 = _interopRequireDefault(_indicator);
	
	__webpack_require__(63);
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  isShown: _react.PropTypes.bool,
	  steps: _react.PropTypes.arrayOf(_react.PropTypes.object),
	  isMac: _react.PropTypes.bool.isRequired,
	  browser: _react.PropTypes.string.isRequired,
	  track: _react.PropTypes.func,
	  locale: _react.PropTypes.string
	};
	
	var defaultProps = {
	  steps: [],
	  isMac: false,
	  browser: 'chrome'
	};
	
	var StepsSection = function (_Component) {
	  _inherits(StepsSection, _Component);
	
	  function StepsSection(props) {
	    _classCallCheck(this, StepsSection);
	
	    var _this = _possibleConstructorReturn(this, (StepsSection.__proto__ || Object.getPrototypeOf(StepsSection)).call(this, props));
	
	    _this.state = {
	      activeStep: null
	    };
	    return _this;
	  }
	
	  _createClass(StepsSection, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(_ref, _ref2) {
	      var prevIsShown = _ref.isShown;
	      var prevActiveStep = _ref2.activeStep;
	      var activeStep = this.state.activeStep;
	      var isShown = this.props.isShown;
	
	
	      if (prevActiveStep !== activeStep || prevIsShown !== isShown) {
	        _indicator2.default.attach({ activeStep: activeStep, isShown: isShown });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var toggleStep = function toggleStep(stepKey) {
	        if (_this2.state.activeStep) {
	          _completeStep2.default.execute();
	        }
	
	        if (_this2.state.activeStep === stepKey) {
	          _this2.setState({ activeStep: false });
	        } else {
	          _this2.setState({ activeStep: stepKey });
	
	          var step = _this2.props.steps.find(function (stepState) {
	            return stepState.key === stepKey;
	          });
	
	          if (step && step.complete) {
	            _completeStep2.default.set(step.complete);
	          }
	        }
	      };
	
	      var checkIsDone = function checkIsDone(steps, key) {
	        var step = steps.find(function (stepState) {
	          return stepState.key === key;
	        }) || {};
	        return step.isDone || false;
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'steps-section' },
	        _react2.default.createElement(
	          _Step2.default,
	          {
	            id: 'personal-room-step',
	            heading: _i18next2.default.t('Personal Meeting Room'),
	            isDone: checkIsDone(this.props.steps, _stepKeys2.default.personalRoom),
	            isActive: this.state.activeStep === _stepKeys2.default.personalRoom,
	            onClick: function onClick() {
	              return toggleStep(_stepKeys2.default.personalRoom);
	            }
	          },
	          _react2.default.createElement(_PersonalRoomStep2.default, null)
	        ),
	        _react2.default.createElement(
	          _Step2.default,
	          {
	            id: 'schedule-step',
	            heading: _i18next2.default.t('Schedule a Meeting'),
	            isDone: checkIsDone(this.props.steps, _stepKeys2.default.schedule),
	            iconType: 'togo-icon-calendar',
	            isActive: this.state.activeStep === _stepKeys2.default.schedule,
	            onClick: function onClick() {
	              return toggleStep(_stepKeys2.default.schedule);
	            }
	          },
	          _react2.default.createElement(_ScheduleStep2.default, null)
	        ),
	        _react2.default.createElement(
	          _Step2.default,
	          {
	            id: 'audio-step',
	            heading: _i18next2.default.t('Explore Audio Options'),
	            isDone: checkIsDone(this.props.steps, _stepKeys2.default.audio),
	            iconType: 'togo-icon-speaker',
	            isActive: this.state.activeStep === _stepKeys2.default.audio,
	            onClick: function onClick() {
	              return toggleStep(_stepKeys2.default.audio);
	            }
	          },
	          _react2.default.createElement(_AudioStep2.default, {
	            isMac: this.props.isMac,
	            locale: this.props.locale
	          })
	        ),
	        _react2.default.createElement(
	          _Step2.default,
	          {
	            id: 'test-meeting-step',
	            heading: _i18next2.default.t('Start a Test Meeting'),
	            isDone: checkIsDone(this.props.steps, _stepKeys2.default.testMeeting),
	            iconType: 'togo-icon-screen',
	            isActive: this.state.activeStep === _stepKeys2.default.testMeeting,
	            onClick: function onClick() {
	              return toggleStep(_stepKeys2.default.testMeeting);
	            }
	          },
	          _react2.default.createElement(_TestMeetingStep2.default, {
	            isMac: this.props.isMac,
	            locale: this.props.locale
	          })
	        ),
	        _react2.default.createElement(
	          _Step2.default,
	          {
	            id: 'calendar-step',
	            heading: _i18next2.default.t('Integrate Calendar'),
	            isDone: checkIsDone(this.props.steps, _stepKeys2.default.calendar),
	            iconType: 'togo-icon-settings',
	            isActive: this.state.activeStep === _stepKeys2.default.calendar,
	            onClick: function onClick() {
	              return toggleStep(_stepKeys2.default.calendar);
	            }
	          },
	          _react2.default.createElement(_CalendarStep2.default, {
	            track: this.props.track
	          })
	        )
	      );
	    }
	  }]);
	
	  return StepsSection;
	}(_react.Component);
	
	exports.default = StepsSection;
	
	
	StepsSection.propTypes = propTypes;
	StepsSection.defaultProps = defaultProps;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StatusIcon = __webpack_require__(13);
	
	var _StatusIcon2 = _interopRequireDefault(_StatusIcon);
	
	var _ActiveIcon = __webpack_require__(17);
	
	var _ActiveIcon2 = _interopRequireDefault(_ActiveIcon);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  id: _react.PropTypes.string,
	  heading: _react.PropTypes.string.isRequired,
	  isDone: _react.PropTypes.bool.isRequired,
	  iconType: _react.PropTypes.string,
	  isActive: _react.PropTypes.bool.isRequired,
	  onClick: _react.PropTypes.func.isRequired,
	  children: _react.PropTypes.element
	};
	
	var defaultProps = {
	  id: ''
	};
	
	var Step = function Step(_ref) {
	  var id = _ref.id,
	      isDone = _ref.isDone,
	      iconType = _ref.iconType,
	      heading = _ref.heading,
	      isActive = _ref.isActive,
	      _onClick = _ref.onClick,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'li',
	    { id: id, className: 'list-unstyled step' },
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-link btn-block heading', onClick: function onClick() {
	          return _onClick();
	        } },
	      _react2.default.createElement(_StatusIcon2.default, { isDone: isDone, iconType: iconType }),
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)('text', { done: isDone }) },
	        heading
	      ),
	      _react2.default.createElement(_ActiveIcon2.default, { isActive: isActive })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('content', { hidden: !isActive }) },
	      children
	    )
	  );
	};
	
	Step.propTypes = propTypes;
	Step.defaultProps = defaultProps;
	
	exports.default = Step;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isDone: _react.PropTypes.bool.isRequired,
	  iconType: _react.PropTypes.string
	};
	
	var StatusIcon = function StatusIcon(_ref) {
	  var isDone = _ref.isDone,
	      iconType = _ref.iconType;
	
	  var iconClass = isDone ? 'togo-icon-check' : iconType;
	
	  return _react2.default.createElement(
	    'span',
	    { className: (0, _classnames2.default)('status-icon', 'togo-icon-stack', { done: isDone }) },
	    _react2.default.createElement('i', { className: 'togo-icon togo-icon-stack-2x togo-icon-radio-circle-hollow' }),
	    _react2.default.createElement('i', { className: (0, _classnames2.default)('togo-icon', 'togo-icon-stack-1x', iconClass) })
	  );
	};
	
	StatusIcon.propTypes = propTypes;
	
	exports.default = StatusIcon;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isActive: _react.PropTypes.bool.isRequired
	};
	
	var ActiveIcon = function ActiveIcon(_ref) {
	  var isActive = _ref.isActive;
	
	  var className = (0, _classnames2.default)({
	    'active-icon': true,
	    'togo-icon': true,
	    'togo-icon-chevron': true,
	    'togo-icon-rotate-180': isActive
	  });
	
	  return _react2.default.createElement('i', { className: className });
	};
	
	ActiveIcon.propTypes = propTypes;
	
	exports.default = ActiveIcon;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  personalRoom: 'PERSONAL_ROOM',
	  schedule: 'SCHEDULE',
	  audio: 'AUDIO',
	  testMeeting: 'TEST_MEETING',
	  calendar: 'CALENDAR'
	};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(24);
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PersonalRoomStep = function PersonalRoomStep() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'personal-room-step' },
	    _i18next2.default.t('Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.')
	  );
	};
	
	exports.default = PersonalRoomStep;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27).default;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(28);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _i18next2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(30);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _ResourceStore = __webpack_require__(31);
	
	var _ResourceStore2 = _interopRequireDefault(_ResourceStore);
	
	var _Translator = __webpack_require__(33);
	
	var _Translator2 = _interopRequireDefault(_Translator);
	
	var _LanguageUtils = __webpack_require__(36);
	
	var _LanguageUtils2 = _interopRequireDefault(_LanguageUtils);
	
	var _PluralResolver = __webpack_require__(37);
	
	var _PluralResolver2 = _interopRequireDefault(_PluralResolver);
	
	var _Interpolator = __webpack_require__(38);
	
	var _Interpolator2 = _interopRequireDefault(_Interpolator);
	
	var _BackendConnector = __webpack_require__(39);
	
	var _BackendConnector2 = _interopRequireDefault(_BackendConnector);
	
	var _CacheConnector = __webpack_require__(40);
	
	var _CacheConnector2 = _interopRequireDefault(_CacheConnector);
	
	var _defaults2 = __webpack_require__(41);
	
	var _postProcessor = __webpack_require__(34);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _v = __webpack_require__(35);
	
	var compat = _interopRequireWildcard(_v);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var I18n = function (_EventEmitter) {
	  _inherits(I18n, _EventEmitter);
	
	  function I18n() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    _classCallCheck(this, I18n);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.options = (0, _defaults2.transformOptions)(options);
	    _this.services = {};
	    _this.logger = _logger2.default;
	    _this.modules = {};
	
	    if (callback && !_this.isInitialized) _this.init(options, callback);
	    return _this;
	  }
	
	  I18n.prototype.init = function init(options, callback) {
	    var _this2 = this;
	
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!options) options = {};
	
	    if (options.compatibilityAPI === 'v1') {
	      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertAPIOptions(options)), {});
	    } else if (options.compatibilityJSON === 'v1') {
	      this.options = _extends({}, (0, _defaults2.get)(), (0, _defaults2.transformOptions)(compat.convertJSONOptions(options)), {});
	    } else {
	      this.options = _extends({}, (0, _defaults2.get)(), this.options, (0, _defaults2.transformOptions)(options));
	    }
	    if (!callback) callback = function callback() {};
	
	    function createClassOnDemand(ClassOrObject) {
	      if (!ClassOrObject) return;
	      if (typeof ClassOrObject === 'function') return new ClassOrObject();
	      return ClassOrObject;
	    }
	
	    // init services
	    if (!this.options.isClone) {
	      if (this.modules.logger) {
	        _logger2.default.init(createClassOnDemand(this.modules.logger), this.options);
	      } else {
	        _logger2.default.init(null, this.options);
	      }
	
	      var lu = new _LanguageUtils2.default(this.options);
	      this.store = new _ResourceStore2.default(this.options.resources, this.options);
	
	      var s = this.services;
	      s.logger = _logger2.default;
	      s.resourceStore = this.store;
	      s.resourceStore.on('added removed', function (lng, ns) {
	        s.cacheConnector.save();
	      });
	      s.languageUtils = lu;
	      s.pluralResolver = new _PluralResolver2.default(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON });
	      s.interpolator = new _Interpolator2.default(this.options);
	
	      s.backendConnector = new _BackendConnector2.default(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.backendConnector.on('*', function (event) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      s.backendConnector.on('loaded', function (loaded) {
	        s.cacheConnector.save();
	      });
	
	      s.cacheConnector = new _CacheConnector2.default(createClassOnDemand(this.modules.cache), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.cacheConnector.on('*', function (event) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      if (this.modules.languageDetector) {
	        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	        s.languageDetector.init(s, this.options.detection, this.options);
	      }
	
	      this.translator = new _Translator2.default(this.services, this.options);
	      // pipe events from translator
	      this.translator.on('*', function (event) {
	        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	          args[_key3 - 1] = arguments[_key3];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	    }
	
	    // append api
	    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle'];
	    storeApi.forEach(function (fcName) {
	      _this2[fcName] = function () {
	        return this.store[fcName].apply(this.store, arguments);
	      };
	    });
	
	    // TODO: COMPATIBILITY remove this
	    if (this.options.compatibilityAPI === 'v1') compat.appendBackwardsAPI(this);
	
	    var load = function load() {
	      _this2.changeLanguage(_this2.options.lng, function (err, t) {
	        _this2.emit('initialized', _this2.options);
	        _this2.logger.log('initialized', _this2.options);
	
	        callback(err, t);
	      });
	    };
	
	    if (this.options.resources || !this.options.initImmediate) {
	      load();
	    } else {
	      setTimeout(load, 0);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.loadResources = function loadResources(callback) {
	    var _this3 = this;
	
	    if (!callback) callback = function callback() {};
	
	    if (!this.options.resources) {
	      var _ret = function () {
	        if (_this3.language && _this3.language.toLowerCase() === 'cimode') return {
	            v: callback()
	          }; // avoid loading resources for cimode
	
	        var toLoad = [];
	
	        var append = function append(lng) {
	          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	          lngs.forEach(function (l) {
	            if (toLoad.indexOf(l) < 0) toLoad.push(l);
	          });
	        };
	
	        append(_this3.language);
	
	        if (_this3.options.preload) {
	          _this3.options.preload.forEach(function (l) {
	            append(l);
	          });
	        }
	
	        _this3.services.cacheConnector.load(toLoad, _this3.options.ns, function () {
	          _this3.services.backendConnector.load(toLoad, _this3.options.ns, callback);
	        });
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    } else {
	      callback(null);
	    }
	  };
	
	  I18n.prototype.reloadResources = function reloadResources(lngs, ns) {
	    if (!lngs) lngs = this.languages;
	    if (!ns) ns = this.options.ns;
	    this.services.backendConnector.reload(lngs, ns);
	  };
	
	  I18n.prototype.use = function use(module) {
	    if (module.type === 'backend') {
	      this.modules.backend = module;
	    }
	
	    if (module.type === 'cache') {
	      this.modules.cache = module;
	    }
	
	    if (module.type === 'logger' || module.log && module.warn && module.warn) {
	      this.modules.logger = module;
	    }
	
	    if (module.type === 'languageDetector') {
	      this.modules.languageDetector = module;
	    }
	
	    if (module.type === 'postProcessor') {
	      _postProcessor2.default.addPostProcessor(module);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
	    var _this4 = this;
	
	    var done = function done(err) {
	      if (lng) {
	        _this4.emit('languageChanged', lng);
	        _this4.logger.log('languageChanged', lng);
	      }
	
	      if (callback) callback(err, function () {
	        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	          args[_key4] = arguments[_key4];
	        }
	
	        return _this4.t.apply(_this4, args);
	      });
	    };
	
	    if (!lng && this.services.languageDetector) lng = this.services.languageDetector.detect();
	
	    if (lng) {
	      this.language = lng;
	      this.languages = this.services.languageUtils.toResolveHierarchy(lng);
	
	      this.translator.changeLanguage(lng);
	
	      if (this.services.languageDetector) this.services.languageDetector.cacheUserLanguage(lng);
	    }
	
	    this.loadResources(function (err) {
	      done(err);
	    });
	  };
	
	  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
	    var _this5 = this;
	
	    var fixedT = function fixedT(key, options) {
	      options = options || {};
	      options.lng = options.lng || fixedT.lng;
	      options.ns = options.ns || fixedT.ns;
	      return _this5.t(key, options);
	    };
	    fixedT.lng = lng;
	    fixedT.ns = ns;
	    return fixedT;
	  };
	
	  I18n.prototype.t = function t() {
	    return this.translator && this.translator.translate.apply(this.translator, arguments);
	  };
	
	  I18n.prototype.exists = function exists() {
	    return this.translator && this.translator.exists.apply(this.translator, arguments);
	  };
	
	  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
	    this.options.defaultNS = ns;
	  };
	
	  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
	    var _this6 = this;
	
	    if (!this.options.ns) return callback && callback();
	    if (typeof ns === 'string') ns = [ns];
	
	    ns.forEach(function (n) {
	      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
	    });
	
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
	    if (typeof lngs === 'string') lngs = [lngs];
	    var preloaded = this.options.preload || [];
	
	    var newLngs = lngs.filter(function (lng) {
	      return preloaded.indexOf(lng) < 0;
	    });
	    // Exit early if all given languages are already preloaded
	    if (!newLngs.length) return callback();
	
	    this.options.preload = preloaded.concat(newLngs);
	    this.loadResources(callback);
	  };
	
	  I18n.prototype.dir = function dir(lng) {
	    if (!lng) lng = this.language;
	    if (!lng) return 'rtl';
	
	    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
	
	    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
	  };
	
	  I18n.prototype.createInstance = function createInstance() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    return new I18n(options, callback);
	  };
	
	  I18n.prototype.cloneInstance = function cloneInstance() {
	    var _this7 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    var clone = new I18n(_extends({}, options, this.options, { isClone: true }), callback);
	    var membersToCopy = ['store', 'services', 'language'];
	    membersToCopy.forEach(function (m) {
	      clone[m] = _this7[m];
	    });
	    clone.translator = new _Translator2.default(clone.services, clone.options);
	    clone.translator.on('*', function (event) {
	      for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	        args[_key5 - 1] = arguments[_key5];
	      }
	
	      clone.emit.apply(clone, [event].concat(args));
	    });
	
	    return clone;
	  };
	
	  return I18n;
	}(_EventEmitter3.default);
	
	exports.default = new I18n();

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var consoleLogger = {
	  type: 'logger',
	
	  log: function log(args) {
	    this._output('log', args);
	  },
	  warn: function warn(args) {
	    this._output('warn', args);
	  },
	  error: function error(args) {
	    this._output('error', args);
	  },
	  _output: function _output(type, args) {
	    if (console && console[type]) console[type].apply(console, Array.prototype.slice.call(args));
	  }
	};
	
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Logger);
	
	    this.subs = [];
	    this.init(concreteLogger, options);
	  }
	
	  Logger.prototype.init = function init(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    this.prefix = options.prefix || 'i18next:';
	    this.logger = concreteLogger || consoleLogger;
	    this.options = options;
	    this.debug = options.debug === false ? false : true;
	  };
	
	  Logger.prototype.setDebug = function setDebug(bool) {
	    this.debug = bool;
	    this.subs.forEach(function (sub) {
	      sub.setDebug(bool);
	    });
	  };
	
	  Logger.prototype.log = function log() {
	    this.forward(arguments, 'log', '', true);
	  };
	
	  Logger.prototype.warn = function warn() {
	    this.forward(arguments, 'warn', '', true);
	  };
	
	  Logger.prototype.error = function error() {
	    this.forward(arguments, 'error', '');
	  };
	
	  Logger.prototype.deprecate = function deprecate() {
	    this.forward(arguments, 'warn', 'WARNING DEPRECATED: ', true);
	  };
	
	  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
	    if (debugOnly && !this.debug) return;
	    if (typeof args[0] === 'string') args[0] = prefix + this.prefix + ' ' + args[0];
	    this.logger[lvl](args);
	  };
	
	  Logger.prototype.create = function create(moduleName) {
	    var sub = new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
	    this.subs.push(sub);
	
	    return sub;
	  };
	
	  // createInstance(options = {}) {
	  //   return new Logger(options, callback);
	  // }
	
	  return Logger;
	}();
	
	;
	
	exports.default = new Logger();

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = function () {
		function EventEmitter() {
			_classCallCheck(this, EventEmitter);
	
			this.observers = {};
		}
	
		EventEmitter.prototype.on = function on(events, listener) {
			var _this = this;
	
			events.split(' ').forEach(function (event) {
				_this.observers[event] = _this.observers[event] || [];
				_this.observers[event].push(listener);
			});
		};
	
		EventEmitter.prototype.off = function off(event, listener) {
			var _this2 = this;
	
			if (!this.observers[event]) {
				return;
			}
	
			this.observers[event].forEach(function () {
				if (!listener) {
					delete _this2.observers[event];
				} else {
					var index = _this2.observers[event].indexOf(listener);
					if (index > -1) {
						_this2.observers[event].splice(index, 1);
					}
				}
			});
		};
	
		EventEmitter.prototype.emit = function emit(event) {
			for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
				args[_key - 1] = arguments[_key];
			}
	
			if (this.observers[event]) {
				this.observers[event].forEach(function (observer) {
					observer.apply(undefined, args);
				});
			}
	
			if (this.observers['*']) {
				this.observers['*'].forEach(function (observer) {
					var _ref;
	
					observer.apply(observer, (_ref = [event]).concat.apply(_ref, args));
				});
			}
		};
	
		return EventEmitter;
	}();
	
	exports.default = EventEmitter;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _EventEmitter2 = __webpack_require__(30);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _utils = __webpack_require__(32);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ResourceStore = function (_EventEmitter) {
	  _inherits(ResourceStore, _EventEmitter);
	
	  function ResourceStore() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };
	
	    _classCallCheck(this, ResourceStore);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.data = data;
	    _this.options = options;
	    return _this;
	  }
	
	  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
	    if (this.options.ns.indexOf(ns) < 0) {
	      this.options.ns.push(ns);
	    }
	  };
	
	  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
	    var index = this.options.ns.indexOf(ns);
	    if (index > -1) {
	      this.options.ns.splice(index, 1);
	    }
	  };
	
	  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var keySeparator = options.keySeparator || this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key && typeof key !== 'string') path = path.concat(key);
	    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	    }
	
	    return utils.getPath(this.data, path);
	  };
	
	  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };
	
	    var keySeparator = this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      value = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    utils.setPath(this.data, path, value);
	
	    if (!options.silent) this.emit('added', lng, ns, key, value);
	  };
	
	  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
	    for (var m in resources) {
	      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
	    }
	    this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
	    var path = [lng, ns];
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      deep = resources;
	      resources = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    var pack = utils.getPath(this.data, path) || {};
	
	    if (deep) {
	      utils.deepExtend(pack, resources, overwrite);
	    } else {
	      pack = _extends({}, pack, resources);
	    }
	
	    utils.setPath(this.data, path, pack);
	
	    this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
	    if (this.hasResourceBundle(lng, ns)) {
	      delete this.data[lng][ns];
	    }
	    this.removeNamespaces(ns);
	
	    this.emit('removed', lng, ns);
	  };
	
	  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
	    return this.getResource(lng, ns) !== undefined;
	  };
	
	  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
	    if (!ns) ns = this.options.defaultNS;
	
	    // TODO: COMPATIBILITY remove extend in v2.1.0
	    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));
	
	    return this.getResource(lng, ns);
	  };
	
	  ResourceStore.prototype.toJSON = function toJSON() {
	    return this.data;
	  };
	
	  return ResourceStore;
	}(_EventEmitter3.default);
	
	exports.default = ResourceStore;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeString = makeString;
	exports.copy = copy;
	exports.setPath = setPath;
	exports.pushPath = pushPath;
	exports.getPath = getPath;
	exports.deepExtend = deepExtend;
	exports.regexEscape = regexEscape;
	exports.escape = escape;
	function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	}
	
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	  while (stack.length > 1) {
	    if (!object) return {};
	
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	    object = object[key];
	  }
	
	  if (!object) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath.obj,
	      k = _getLastOfPath.k;
	
	  obj[k] = newValue;
	}
	
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath2.obj,
	      k = _getLastOfPath2.k;
	
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	      obj = _getLastOfPath3.obj,
	      k = _getLastOfPath3.k;
	
	  if (!obj) return undefined;
	  return obj[k];
	}
	
	function deepExtend(target, source, overwrite) {
	  for (var prop in source) {
	    if (prop in target) {
	      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
	      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	        if (overwrite) target[prop] = source[prop];
	      } else {
	        deepExtend(target[prop], source[prop], overwrite);
	      }
	    } else {
	      target[prop] = source[prop];
	    }
	  }return target;
	}
	
	function regexEscape(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/* eslint-disable */
	var _entityMap = {
	  "&": "&amp;",
	  "<": "&lt;",
	  ">": "&gt;",
	  '"': '&quot;',
	  "'": '&#39;',
	  "/": '&#x2F;'
	};
	/* eslint-enable */
	
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  } else {
	    return data;
	  }
	}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(30);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _postProcessor = __webpack_require__(34);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _v = __webpack_require__(35);
	
	var compat = _interopRequireWildcard(_v);
	
	var _utils = __webpack_require__(32);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Translator = function (_EventEmitter) {
	  _inherits(Translator, _EventEmitter);
	
	  function Translator(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Translator);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    utils.copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector'], services, _this);
	
	    _this.options = options;
	    _this.logger = _logger2.default.create('translator');
	    return _this;
	  }
	
	  Translator.prototype.changeLanguage = function changeLanguage(lng) {
	    if (lng) this.language = lng;
	  };
	
	  Translator.prototype.exists = function exists(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };
	
	    if (this.options.compatibilityAPI === 'v1') {
	      options = compat.convertTOptions(options);
	    }
	
	    return this.resolve(key, options) !== undefined;
	  };
	
	  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
	    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	    if (nsSeparator === undefined) nsSeparator = ':';
	
	    var namespaces = options.ns || this.options.defaultNS;
	    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
	      var parts = key.split(nsSeparator);
	      namespaces = parts[0];
	      key = parts[1];
	    }
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    return {
	      key: key,
	      namespaces: namespaces
	    };
	  };
	
	  Translator.prototype.translate = function translate(keys) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
	      options = this.options.overloadTranslationOptionHandler(arguments);
	    } else if (this.options.compatibilityAPI === 'v1') {
	      options = compat.convertTOptions(options);
	    }
	
	    // non valid keys handling
	    if (keys === undefined || keys === null || keys === '') return '';
	    if (typeof keys === 'number') keys = String(keys);
	    if (typeof keys === 'string') keys = [keys];
	
	    // return key on CIMode
	    var lng = options.lng || this.language;
	    if (lng && lng.toLowerCase() === 'cimode') return keys[keys.length - 1];
	
	    // separators
	    var keySeparator = options.keySeparator || this.options.keySeparator || '.';
	
	    // get namespace(s)
	
	    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	        key = _extractFromKey.key,
	        namespaces = _extractFromKey.namespaces;
	
	    var namespace = namespaces[namespaces.length - 1];
	
	    // resolve from store
	    var res = this.resolve(keys, options);
	
	    var resType = Object.prototype.toString.apply(res);
	    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	
	    // object
	    if (res && typeof res !== 'string' && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
	      if (!options.returnObjects && !this.options.returnObjects) {
	        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(key, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
	      }
	
	      var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy
	
	      for (var m in res) {
	        copy[m] = this.translate('' + key + keySeparator + m, _extends({ joinArrays: false, ns: namespaces }, options));
	      }
	      res = copy;
	    }
	    // array special treatment
	    else if (joinArrays && resType === '[object Array]') {
	        res = res.join(joinArrays);
	        if (res) res = this.extendTranslation(res, key, options);
	      }
	      // string, empty or null
	      else {
	          var usedDefault = false,
	              usedKey = false;
	
	          // fallback value
	          if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
	            usedDefault = true;
	            res = options.defaultValue;
	          }
	          if (!this.isValidLookup(res)) {
	            usedKey = true;
	            res = key;
	          }
	
	          // save missing
	          if (usedKey || usedDefault) {
	            this.logger.log('missingKey', lng, namespace, key, res);
	
	            var lngs = [];
	            var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	            if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	              for (var i = 0; i < fallbackLngs.length; i++) {
	                lngs.push(fallbackLngs[i]);
	              }
	            } else if (this.options.saveMissingTo === 'all') {
	              lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	            } else {
	              //(this.options.saveMissingTo === 'current' || (this.options.saveMissingTo === 'fallback' && this.options.fallbackLng[0] === false) ) {
	              lngs.push(options.lng || this.language);
	            }
	
	            if (this.options.saveMissing) {
	              if (this.options.missingKeyHandler) {
	                this.options.missingKeyHandler(lngs, namespace, key, res);
	              } else if (this.backendConnector && this.backendConnector.saveMissing) {
	                this.backendConnector.saveMissing(lngs, namespace, key, res);
	              }
	            }
	
	            this.emit('missingKey', lngs, namespace, key, res);
	          }
	
	          // extend
	          res = this.extendTranslation(res, key, options);
	
	          // append namespace if still key
	          if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;
	
	          // parseMissingKeyHandler
	          if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
	        }
	
	    // return
	    return res;
	  };
	
	  Translator.prototype.extendTranslation = function extendTranslation(res, key, options) {
	    var _this2 = this;
	
	    if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));
	
	    // interpolate
	    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	    if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
	    res = this.interpolator.interpolate(res, data, this.language);
	
	    // nesting
	    res = this.interpolator.nest(res, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _this2.translate.apply(_this2, args);
	    }, options);
	
	    if (options.interpolation) this.interpolator.reset();
	
	    // post process
	    var postProcess = options.postProcess || this.options.postProcess;
	    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	
	    if (res !== undefined && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	      res = _postProcessor2.default.handle(postProcessorNames, res, key, options, this);
	    }
	
	    return res;
	  };
	
	  Translator.prototype.resolve = function resolve(keys) {
	    var _this3 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var found = void 0;
	
	    if (typeof keys === 'string') keys = [keys];
	
	    // forEach possible key
	    keys.forEach(function (k) {
	      if (_this3.isValidLookup(found)) return;
	
	      var _extractFromKey2 = _this3.extractFromKey(k, options),
	          key = _extractFromKey2.key,
	          namespaces = _extractFromKey2.namespaces;
	
	      if (_this3.options.fallbackNS) namespaces = namespaces.concat(_this3.options.fallbackNS);
	
	      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
	
	      var codes = options.lngs ? options.lngs : _this3.languageUtils.toResolveHierarchy(options.lng || _this3.language);
	
	      namespaces.forEach(function (ns) {
	        if (_this3.isValidLookup(found)) return;
	
	        codes.forEach(function (code) {
	          if (_this3.isValidLookup(found)) return;
	
	          var finalKey = key;
	          var finalKeys = [finalKey];
	
	          var pluralSuffix = void 0;
	          if (needsPluralHandling) pluralSuffix = _this3.pluralResolver.getSuffix(code, options.count);
	
	          // fallback for plural if context not found
	          if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
	
	          // get key for context if needed
	          if (needsContextHandling) finalKeys.push(finalKey += '' + _this3.options.contextSeparator + options.context);
	
	          // get key for plural if needed
	          if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
	
	          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
	          var possibleKey = void 0;
	          while (possibleKey = finalKeys.pop()) {
	            if (_this3.isValidLookup(found)) continue;
	            found = _this3.getResource(code, ns, possibleKey, options);
	          }
	        });
	      });
	    });
	
	    return found;
	  };
	
	  Translator.prototype.isValidLookup = function isValidLookup(res) {
	    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	  };
	
	  Translator.prototype.getResource = function getResource(code, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    return this.resourceStore.getResource(code, ns, key, options);
	  };
	
	  return Translator;
	}(_EventEmitter3.default);
	
	exports.default = Translator;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  processors: {},
	
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	
	    return value;
	  }
	};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertAPIOptions = convertAPIOptions;
	exports.convertJSONOptions = convertJSONOptions;
	exports.convertTOptions = convertTOptions;
	exports.appendBackwardsAPI = appendBackwardsAPI;
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function convertInterpolation(options) {
	
	  options.interpolation = {
	    unescapeSuffix: 'HTML'
	  };
	
	  options.interpolation.prefix = options.interpolationPrefix || '__';
	  options.interpolation.suffix = options.interpolationSuffix || '__';
	  options.interpolation.escapeValue = options.escapeInterpolation || false;
	
	  options.interpolation.nestingPrefix = options.reusePrefix || '$t(';
	  options.interpolation.nestingSuffix = options.reuseSuffix || ')';
	
	  return options;
	}
	
	function convertAPIOptions(options) {
	  if (options.resStore) options.resources = options.resStore;
	
	  if (options.ns && options.ns.defaultNs) {
	    options.defaultNS = options.ns.defaultNs;
	    options.ns = options.ns.namespaces;
	  } else {
	    options.defaultNS = options.ns || 'translation';
	  }
	
	  if (options.fallbackToDefaultNS && options.defaultNS) options.fallbackNS = options.defaultNS;
	
	  options.saveMissing = options.sendMissing;
	  options.saveMissingTo = options.sendMissingTo || 'current';
	  options.returnNull = options.fallbackOnNull ? false : true;
	  options.returnEmptyString = options.fallbackOnEmpty ? false : true;
	  options.returnObjects = options.returnObjectTrees;
	  options.joinArrays = '\n';
	
	  options.returnedObjectHandler = options.objectTreeKeyHandler;
	  options.parseMissingKeyHandler = options.parseMissingKey;
	  options.appendNamespaceToMissingKey = true;
	
	  options.nsSeparator = options.nsseparator;
	  options.keySeparator = options.keyseparator;
	
	  if (options.shortcutFunction === 'sprintf') {
	    options.overloadTranslationOptionHandler = function (args) {
	      var values = [];
	
	      for (var i = 1; i < args.length; i++) {
	        values.push(args[i]);
	      }
	
	      return {
	        postProcess: 'sprintf',
	        sprintf: values
	      };
	    };
	  }
	
	  options.whitelist = options.lngWhitelist;
	  options.preload = options.preload;
	  if (options.load === 'current') options.load = 'currentOnly';
	  if (options.load === 'unspecific') options.load = 'languageOnly';
	
	  // backend
	  options.backend = options.backend || {};
	  options.backend.loadPath = options.resGetPath || 'locales/__lng__/__ns__.json';
	  options.backend.addPath = options.resPostPath || 'locales/add/__lng__/__ns__';
	  options.backend.allowMultiLoading = options.dynamicLoad;
	
	  // cache
	  options.cache = options.cache || {};
	  options.cache.prefix = 'res_';
	  options.cache.expirationTime = 7 * 24 * 60 * 60 * 1000;
	  options.cache.enabled = options.useLocalStorage ? true : false;
	
	  options = convertInterpolation(options);
	  if (options.defaultVariables) options.interpolation.defaultVariables = options.defaultVariables;
	
	  // TODO: deprecation
	  // if (options.getAsync === false) throw deprecation error
	
	  return options;
	}
	
	function convertJSONOptions(options) {
	  options = convertInterpolation(options);
	  options.joinArrays = '\n';
	
	  return options;
	}
	
	function convertTOptions(options) {
	  if (options.interpolationPrefix || options.interpolationSuffix || options.escapeInterpolation) {
	    options = convertInterpolation(options);
	  }
	
	  options.nsSeparator = options.nsseparator;
	  options.keySeparator = options.keyseparator;
	
	  options.returnObjects = options.returnObjectTrees;
	
	  return options;
	}
	
	function appendBackwardsAPI(i18n) {
	  i18n.lng = function () {
	    _logger2.default.deprecate('i18next.lng() can be replaced by i18next.language for detected language or i18next.languages for languages ordered by translation lookup.');
	    return i18n.services.languageUtils.toResolveHierarchy(i18n.language)[0];
	  };
	
	  i18n.preload = function (lngs, cb) {
	    _logger2.default.deprecate('i18next.preload() can be replaced with i18next.loadLanguages()');
	    i18n.loadLanguages(lngs, cb);
	  };
	
	  i18n.setLng = function (lng, options, callback) {
	    _logger2.default.deprecate('i18next.setLng() can be replaced with i18next.changeLanguage() or i18next.getFixedT() to get a translation function with fixed language or namespace.');
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!options) options = {};
	
	    if (options.fixLng === true) {
	      if (callback) return callback(null, i18n.getFixedT(lng));
	    }
	
	    i18n.changeLanguage(lng, callback);
	  };
	
	  i18n.addPostProcessor = function (name, fc) {
	    _logger2.default.deprecate('i18next.addPostProcessor() can be replaced by i18next.use({ type: \'postProcessor\', name: \'name\', process: fc })');
	    i18n.use({
	      type: 'postProcessor',
	      name: name,
	      process: fc
	    });
	  };
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck(this, LanguageUtil);
	
	    this.options = options;
	
	    this.whitelist = this.options.whitelist || false;
	    this.logger = _logger2.default.create('languageUtils');
	  }
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (code.indexOf('-') < 0) return code;
	
	    var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
	    var p = code.split('-');
	    return this.formatLanguageCode(specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0]);
	  };
	
	  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
	    if (code.indexOf('-') < 0) return null;
	
	    var p = code.split('-');
	    if (p.length === 2) return null;
	    p.pop();
	    return this.formatLanguageCode(p.join('-'));
	  };
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (code.indexOf('-') < 0) return code;
	
	    var specialCases = ['NB-NO', 'NN-NO', 'nb-NO', 'nn-NO', 'nb-no', 'nn-no'];
	    var p = code.split('-');
	    return this.formatLanguageCode(specialCases.indexOf(code) > -1 ? p[1].toLowerCase() : p[0]);
	  };
	
	  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
	    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	      var p = code.split('-');
	
	      if (this.options.lowerCaseLng) {
	        p = p.map(function (part) {
	          return part.toLowerCase();
	        });
	      } else if (p.length === 2) {
	        p[0] = p[0].toLowerCase();
	        p[1] = p[1].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	      } else if (p.length === 3) {
	        p[0] = p[0].toLowerCase();
	
	        // if lenght 2 guess it's a country
	        if (p[1].length === 2) p[1] = p[1].toUpperCase();
	        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	      }
	
	      return p.join('-');
	    } else {
	      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	    }
	  };
	
	  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code, exactMatch) {
	    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist && !exactMatch) {
	      code = this.getLanguagePartFromCode(code);
	    }
	    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1 ? true : false;
	  };
	
	  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
	    if (!fallbacks) return [];
	    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	
	    // asume we have an object defining fallbacks
	    var found = fallbacks[code];
	    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	    if (!found) found = fallbacks[this.formatLanguageCode(code)];
	    if (!found) found = fallbacks.default;
	
	    return found || [];
	  };
	
	  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
	    var _this = this;
	
	    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	
	    var codes = [];
	    var addCode = function addCode(code) {
	      var exactMatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!code) return;
	      if (_this.isWhitelisted(code, exactMatch)) {
	        codes.push(code);
	      } else {
	        _this.logger.warn('rejecting non-whitelisted language code: ' + code);
	      }
	    };
	
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code), true);
	      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code), true);
	      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	    } else if (typeof code === 'string') {
	      addCode(this.formatLanguageCode(code));
	    }
	
	    fallbackCodes.forEach(function (fc) {
	      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
	    });
	
	    return codes;
	  };
	
	  return LanguageUtil;
	}();
	
	;
	
	exports.default = LanguageUtil;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
	/* eslint-disable */
	var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'es_ar', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt', 'pt_br', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];
	
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  }
	};
	/* eslint-enable */
	
	function createRules() {
	  var l,
	      rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      return rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PluralResolver);
	
	    this.languageUtils = languageUtils;
	    this.options = options;
	
	    this.logger = _logger2.default.create('pluralResolver');
	
	    this.rules = createRules();
	  }
	
	  PluralResolver.prototype.addRule = function addRule(lng, obj) {
	    this.rules[lng] = obj;
	  };
	
	  PluralResolver.prototype.getRule = function getRule(code) {
	    return this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	  };
	
	  PluralResolver.prototype.needsPlural = function needsPlural(code) {
	    var rule = this.getRule(code);
	
	    return rule && rule.numbers.length <= 1 ? false : true;
	  };
	
	  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
	    var _this = this;
	
	    var rule = this.getRule(code);
	
	    if (rule) {
	      var _ret = function () {
	        if (rule.numbers.length === 1) return {
	            v: ''
	          }; // only singular
	
	        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	        var suffix = rule.numbers[idx];
	
	        // special treatment for lngs only having singular and plural
	        if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
	          if (suffix === 2) {
	            suffix = 'plural';
	          } else if (suffix === 1) {
	            suffix = '';
	          }
	        }
	
	        var returnSuffix = function returnSuffix() {
	          return _this.options.prepend && suffix.toString() ? _this.options.prepend + suffix.toString() : suffix.toString();
	        };
	
	        // COMPATIBILITY JSON
	        // v1
	        if (_this.options.compatibilityJSON === 'v1') {
	          if (suffix === 1) return {
	              v: ''
	            };
	          if (typeof suffix === 'number') return {
	              v: '_plural_' + suffix.toString()
	            };
	          return {
	            v: returnSuffix()
	          };
	        }
	        // v2
	        else if (_this.options.compatibilityJSON === 'v2' || rule.numbers.length === 2 && rule.numbers[0] === 1) {
	            return {
	              v: returnSuffix()
	            };
	          }
	          // v3 - gettext index
	          else if (rule.numbers.length === 2 && rule.numbers[0] === 1) {
	              return {
	                v: returnSuffix()
	              };
	            }
	        return {
	          v: _this.options.prepend && idx.toString() ? _this.options.prepend + idx.toString() : idx.toString()
	        };
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	    } else {
	      this.logger.warn('no plural rule found for: ' + code);
	      return '';
	    }
	  };
	
	  return PluralResolver;
	}();
	
	;
	
	exports.default = PluralResolver;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(32);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Interpolator);
	
	    this.logger = _logger2.default.create('interpolator');
	
	    this.init(options, true);
	  }
	
	  Interpolator.prototype.init = function init() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var reset = arguments[1];
	
	    if (reset) {
	      this.options = options;
	      this.format = options.interpolation && options.interpolation.format || function (value) {
	        return value;
	      };
	    }
	    if (!options.interpolation) options.interpolation = { escapeValue: true };
	
	    var iOpts = options.interpolation;
	
	    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	
	    this.prefix = iOpts.prefix ? utils.regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	    this.suffix = iOpts.suffix ? utils.regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	    this.formatSeparator = iOpts.formatSeparator ? utils.regexEscape(iOpts.formatSeparator) : iOpts.formatSeparator || ',';
	
	    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	
	    this.nestingPrefix = iOpts.nestingPrefix ? utils.regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || utils.regexEscape('$t(');
	    this.nestingSuffix = iOpts.nestingSuffix ? utils.regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || utils.regexEscape(')');
	
	    // the regexp
	    this.resetRegExp();
	  };
	
	  Interpolator.prototype.reset = function reset() {
	    if (this.options) this.init(this.options);
	  };
	
	  Interpolator.prototype.resetRegExp = function resetRegExp() {
	    // the regexp
	    var regexpStr = this.prefix + '(.+?)' + this.suffix;
	    this.regexp = new RegExp(regexpStr, 'g');
	
	    var regexpUnescapeStr = this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
	    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	
	    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
	    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	  };
	
	  Interpolator.prototype.interpolate = function interpolate(str, data, lng) {
	    var _this = this;
	
	    var match = void 0,
	        value = void 0;
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    var handleFormat = function handleFormat(key) {
	      if (key.indexOf(_this.formatSeparator) < 0) return utils.getPath(data, key);
	
	      var p = key.split(_this.formatSeparator);
	      var k = p.shift().trim();
	      var f = p.join(_this.formatSeparator).trim();
	
	      return _this.format(utils.getPath(data, k), f, lng);
	    };
	
	    this.resetRegExp();
	
	    // unescape if has unescapePrefix/Suffix
	    while (match = this.regexpUnescape.exec(str)) {
	      var _value = handleFormat(match[1].trim());
	      str = str.replace(match[0], _value);
	      this.regexpUnescape.lastIndex = 0;
	    }
	
	    // regular escape on demand
	    while (match = this.regexp.exec(str)) {
	      value = handleFormat(match[1].trim());
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	        value = '';
	      }
	      value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  Interpolator.prototype.nest = function nest(str, fc) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var match = void 0,
	        value = void 0;
	
	    var clonedOptions = JSON.parse(JSON.stringify(options));
	    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
	    function handleHasOptions(key) {
	      if (key.indexOf(',') < 0) return key;
	
	      var p = key.split(',');
	      key = p.shift();
	      var optionsString = p.join(',');
	      optionsString = this.interpolate(optionsString, clonedOptions);
	
	      try {
	        clonedOptions = JSON.parse(optionsString);
	      } catch (e) {
	        this.logger.error('failed parsing options string in nesting for key ' + key, e);
	      }
	
	      return key;
	    }
	
	    // regular escape on demand
	    while (match = this.nestingRegexp.exec(str)) {
	      value = fc(handleHasOptions.call(this, match[1].trim()), clonedOptions);
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	        value = '';
	      }
	      value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  return Interpolator;
	}();
	
	exports.default = Interpolator;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _utils = __webpack_require__(32);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(30);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function remove(arr, what) {
	  var found = arr.indexOf(what);
	
	  while (found !== -1) {
	    arr.splice(found, 1);
	    found = arr.indexOf(what);
	  }
	}
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(backend, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.backend = backend;
	    _this.store = store;
	    _this.services = services;
	    _this.options = options;
	    _this.logger = _logger2.default.create('backendConnector');
	
	    _this.state = {};
	    _this.queue = [];
	
	    _this.backend && _this.backend.init && _this.backend.init(services, options.backend, options);
	    return _this;
	  }
	
	  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, callback) {
	    var _this2 = this;
	
	    // find what needs to be loaded
	    var toLoad = [],
	        pending = [],
	        toLoadLanguages = [],
	        toLoadNamespaces = [];
	
	    languages.forEach(function (lng) {
	      var hasAllNamespaces = true;
	
	      namespaces.forEach(function (ns) {
	        var name = lng + '|' + ns;
	
	        if (_this2.store.hasResourceBundle(lng, ns)) {
	          _this2.state[name] = 2; // loaded
	        } else if (_this2.state[name] < 0) {
	          // nothing to do for err
	        } else if (_this2.state[name] === 1) {
	          if (pending.indexOf(name) < 0) pending.push(name);
	        } else {
	          _this2.state[name] = 1; // pending
	
	          hasAllNamespaces = false;
	
	          if (pending.indexOf(name) < 0) pending.push(name);
	          if (toLoad.indexOf(name) < 0) toLoad.push(name);
	          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
	        }
	      });
	
	      if (!hasAllNamespaces) toLoadLanguages.push(lng);
	    });
	
	    if (toLoad.length || pending.length) {
	      this.queue.push({
	        pending: pending,
	        loaded: {},
	        errors: [],
	        callback: callback
	      });
	    }
	
	    return {
	      toLoad: toLoad,
	      pending: pending,
	      toLoadLanguages: toLoadLanguages,
	      toLoadNamespaces: toLoadNamespaces
	    };
	  };
	
	  Connector.prototype.loaded = function loaded(name, err, data) {
	    var _this3 = this;
	
	    var _name$split = name.split('|'),
	        _name$split2 = _slicedToArray(_name$split, 2),
	        lng = _name$split2[0],
	        ns = _name$split2[1];
	
	    if (err) this.emit('failedLoading', lng, ns, err);
	
	    if (data) {
	      this.store.addResourceBundle(lng, ns, data);
	    }
	
	    // set loaded
	    this.state[name] = err ? -1 : 2;
	    // callback if ready
	    this.queue.forEach(function (q) {
	      utils.pushPath(q.loaded, [lng], ns);
	      remove(q.pending, name);
	
	      if (err) q.errors.push(err);
	
	      if (q.pending.length === 0 && !q.done) {
	        q.errors.length ? q.callback(q.errors) : q.callback();
	        _this3.emit('loaded', q.loaded);
	        q.done = true;
	      }
	    });
	
	    // remove done load requests
	    this.queue = this.queue.filter(function (q) {
	      return !q.done;
	    });
	  };
	
	  Connector.prototype.read = function read(lng, ns, fcName, tried, wait, callback) {
	    var _this4 = this;
	
	    if (!tried) tried = 0;
	    if (!wait) wait = 250;
	
	    if (!lng.length) return callback(null, {}); // noting to load
	
	    this.backend[fcName](lng, ns, function (err, data) {
	      if (err && data /* = retryFlag */ && tried < 5) {
	        setTimeout(function () {
	          _this4.read.call(_this4, lng, ns, fcName, ++tried, wait * 2, callback);
	        }, wait);
	        return;
	      }
	      callback(err, data);
	    });
	  };
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    var _this5 = this;
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	      return callback && callback();
	    }
	    var options = _extends({}, this.backend.options, this.options.backend);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    var toLoad = this.queueLoad(languages, namespaces, callback);
	    if (!toLoad.toLoad.length) {
	      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
	      return; // pendings will trigger callback
	    }
	
	    // load with multi-load
	    if (options.allowMultiLoading && this.backend.readMulti) {
	      this.read(toLoad.toLoadLanguages, toLoad.toLoadNamespaces, 'readMulti', null, null, function (err, data) {
	        if (err) _this5.logger.warn('loading namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading failed', err);
	        if (!err && data) _this5.logger.log('loaded namespaces ' + toLoad.toLoadNamespaces.join(', ') + ' for languages ' + toLoad.toLoadLanguages.join(', ') + ' via multiloading', data);
	
	        toLoad.toLoad.forEach(function (name) {
	          var _name$split3 = name.split('|'),
	              _name$split4 = _slicedToArray(_name$split3, 2),
	              l = _name$split4[0],
	              n = _name$split4[1];
	
	          var bundle = utils.getPath(data, [l, n]);
	          if (bundle) {
	            _this5.loaded(name, err, bundle);
	          } else {
	            var _err = 'loading namespace ' + n + ' for language ' + l + ' via multiloading failed';
	            _this5.loaded(name, _err);
	            _this5.logger.error(_err);
	          }
	        });
	      });
	    }
	
	    // load one by one
	    else {
	        (function () {
	          var readOne = function readOne(name) {
	            var _this6 = this;
	
	            var _name$split5 = name.split('|'),
	                _name$split6 = _slicedToArray(_name$split5, 2),
	                lng = _name$split6[0],
	                ns = _name$split6[1];
	
	            this.read(lng, ns, 'read', null, null, function (err, data) {
	              if (err) _this6.logger.warn('loading namespace ' + ns + ' for language ' + lng + ' failed', err);
	              if (!err && data) _this6.logger.log('loaded namespace ' + ns + ' for language ' + lng, data);
	
	              _this6.loaded(name, err, data);
	            });
	          };
	
	          ;
	
	          toLoad.toLoad.forEach(function (name) {
	            readOne.call(_this5, name);
	          });
	        })();
	      }
	  };
	
	  Connector.prototype.reload = function reload(languages, namespaces) {
	    var _this7 = this;
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	    }
	    var options = _extends({}, this.backend.options, this.options.backend);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    // load with multi-load
	    if (options.allowMultiLoading && this.backend.readMulti) {
	      this.read(languages, namespaces, 'readMulti', null, null, function (err, data) {
	        if (err) _this7.logger.warn('reloading namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading failed', err);
	        if (!err && data) _this7.logger.log('reloaded namespaces ' + namespaces.join(', ') + ' for languages ' + languages.join(', ') + ' via multiloading', data);
	
	        languages.forEach(function (l) {
	          namespaces.forEach(function (n) {
	            var bundle = utils.getPath(data, [l, n]);
	            if (bundle) {
	              _this7.loaded(l + '|' + n, err, bundle);
	            } else {
	              var _err2 = 'reloading namespace ' + n + ' for language ' + l + ' via multiloading failed';
	              _this7.loaded(l + '|' + n, _err2);
	              _this7.logger.error(_err2);
	            }
	          });
	        });
	      });
	    }
	
	    // load one by one
	    else {
	        (function () {
	          var readOne = function readOne(name) {
	            var _this8 = this;
	
	            var _name$split7 = name.split('|'),
	                _name$split8 = _slicedToArray(_name$split7, 2),
	                lng = _name$split8[0],
	                ns = _name$split8[1];
	
	            this.read(lng, ns, 'read', null, null, function (err, data) {
	              if (err) _this8.logger.warn('reloading namespace ' + ns + ' for language ' + lng + ' failed', err);
	              if (!err && data) _this8.logger.log('reloaded namespace ' + ns + ' for language ' + lng, data);
	
	              _this8.loaded(name, err, data);
	            });
	          };
	
	          ;
	
	          languages.forEach(function (l) {
	            namespaces.forEach(function (n) {
	              readOne.call(_this7, l + '|' + n);
	            });
	          });
	        })();
	      }
	  };
	
	  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue) {
	    if (this.backend && this.backend.create) this.backend.create(languages, namespace, key, fallbackValue);
	
	    // write to store to avoid resending
	    if (!languages || !languages[0]) return;
	    this.store.addResource(languages[0], namespace, key, fallbackValue);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(32);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(29);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(30);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(cache, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.cache = cache;
	    _this.store = store;
	    _this.services = services;
	    _this.options = options;
	    _this.logger = _logger2.default.create('cacheConnector');
	
	    _this.cache && _this.cache.init && _this.cache.init(services, options.cache, options);
	    return _this;
	  }
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    var _this2 = this;
	
	    if (!this.cache) return callback && callback();
	    var options = _extends({}, this.cache.options, this.options.cache);
	
	    if (typeof languages === 'string') languages = this.services.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    if (options.enabled) {
	      this.cache.load(languages, function (err, data) {
	        if (err) _this2.logger.error('loading languages ' + languages.join(', ') + ' from cache failed', err);
	        if (data) {
	          for (var l in data) {
	            for (var n in data[l]) {
	              if (n === 'i18nStamp') continue;
	              var bundle = data[l][n];
	              if (bundle) _this2.store.addResourceBundle(l, n, bundle);
	            }
	          }
	        }
	        if (callback) callback();
	      });
	    } else {
	      if (callback) callback();
	    }
	  };
	
	  Connector.prototype.save = function save() {
	    if (this.cache && this.options.cache && this.options.cache.enabled) this.cache.save(this.store.data);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.transformOptions = transformOptions;
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false, // string or array of namespaces
	
	    whitelist: false, // array with whitelisted languages
	    nonExplicitWhitelist: false,
	    load: 'all', // | currentOnly | languageOnly
	    preload: false, // array with preload languages
	
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	
	    saveMissing: false, // enable to send missing values
	    saveMissingTo: 'fallback', // 'current' || 'all'
	    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
	
	    postProcess: false, // string or array of postProcessor names
	    returnNull: true, // allows null value as valid translation
	    returnEmptyString: true, // allows empty string value as valid translation
	    returnObjects: false,
	    joinArrays: false, // or string to join array
	    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
	    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
	    appendNamespaceToMissingKey: false,
	    overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
	      return { defaultValue: args[1] };
	    },
	
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      // prefixEscaped: '{{',
	      // suffixEscaped: '}}',
	      // unescapeSuffix: '',
	      unescapePrefix: '-',
	
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      // nestingPrefixEscaped: '$t(',
	      // nestingSuffixEscaped: ')',
	      defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
	    }
	  };
	}
	
	function transformOptions(options) {
	  // create namespace object if namespace is passed in as string
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	
	  // extend whitelist with cimode
	  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) options.whitelist.push('cimode');
	
	  return options;
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(43);
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScheduleStep = function ScheduleStep() {
	  var dangerousHtml = {
	    __html: _i18next2.default.t('Copy %s share invitation', '&amp;')
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'schedule-step' },
	    _i18next2.default.t('Let\'s schedule your first meeting!'),
	    _react2.default.createElement(
	      'ul',
	      { className: 'list-unstyled' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'list-number' },
	          '1'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-step' },
	          _i18next2.default.t('Click Schedule')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'list-number' },
	          '2'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-step' },
	          _i18next2.default.t('Add a meeting title')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'list-number' },
	          '3'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'list-step' },
	          _i18next2.default.t('Click Save')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'span',
	          { className: 'list-number' },
	          '4'
	        ),
	        _react2.default.createElement('div', {
	          className: 'list-step',
	          dangerouslySetInnerHTML: dangerousHtml
	        })
	      )
	    )
	  );
	};
	
	exports.default = ScheduleStep;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(46);
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isMac: _react.PropTypes.bool.isRequired,
	  locale: _react.PropTypes.string
	};
	
	var AudioStep = function AudioStep(_ref) {
	  var isMac = _ref.isMac,
	      locale = _ref.locale;
	
	  var bucketUrl = 'https://cdn.gotomeet.at/get-set-up';
	  var os = isMac ? 'mac' : 'win';
	
	  var connectImgSrc = bucketUrl + '/audio-choice-' + os + '-' + locale + '.png';
	  var dialImgSrc = bucketUrl + '/dial-in-' + os + '-' + locale + '.png';
	  var soundImgSrc = bucketUrl + '/sound-best.png';
	
	  var dangerousHtmlDialIn = {
	    __html: _i18next2.default.t('Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.', '&amp;')
	  };
	  var dangerousHtmlSoundYourBest = {
	    __html: _i18next2.default.t('To dial in by phone, call the number in the meeting invitation, and then enter your access code &amp; Audio PIN. %sRecommended if you have a slow internet connection.', '<br />')
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'audio-step' },
	    _i18next2.default.t('Learn about different audio features and options available.'),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _i18next2.default.t('Enjoy two ways to connect')
	    ),
	    _react2.default.createElement('img', {
	      src: connectImgSrc,
	      alt: _i18next2.default.t('Choose between using telephone audio and you computer\'s microphone and speakers')
	    }),
	    _react2.default.createElement('p', { dangerouslySetInnerHTML: dangerousHtmlDialIn }),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _i18next2.default.t('Easily dial in')
	    ),
	    _react2.default.createElement('img', {
	      src: dialImgSrc,
	      alt: _i18next2.default.t('Dial in using number and PIN')
	    }),
	    _react2.default.createElement('p', { dangerouslySetInnerHTML: dangerousHtmlSoundYourBest }),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _i18next2.default.t('Sound your best')
	    ),
	    _react2.default.createElement('img', {
	      src: soundImgSrc,
	      alt: _i18next2.default.t('Sound your best')
	    }),
	    _react2.default.createElement(
	      'p',
	      null,
	      _i18next2.default.t('A headset and a good internet connection will keep you and your attendees sounding your best.')
	    )
	  );
	};
	
	AudioStep.propTypes = propTypes;
	
	exports.default = AudioStep;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(49);
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isMac: _react.PropTypes.bool.isRequired,
	  locale: _react.PropTypes.string
	};
	
	var TestMeetingStep = function TestMeetingStep(_ref) {
	  var isMac = _ref.isMac,
	      locale = _ref.locale;
	
	  var bucketUrl = 'https://cdn.gotomeet.at/get-set-up';
	  var os = isMac ? 'mac' : 'win';
	
	  var inviteImgSrc = bucketUrl + '/invite-' + os + '-' + locale + '.png';
	  var webcamImgSrc = bucketUrl + '/share-webcam-' + os + '-' + locale + '.png';
	  var screenImgSrc = bucketUrl + '/share-screen-' + os + '-' + locale + '.png';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'test-meeting-step' },
	    _i18next2.default.t('Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.'),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _i18next2.default.t('Invite attendees')
	    ),
	    _react2.default.createElement('img', {
	      src: inviteImgSrc,
	      alt: _i18next2.default.t('Share test meeting')
	    }),
	    _react2.default.createElement(
	      'p',
	      null,
	      _i18next2.default.t('To share your test meeting with a friend or colleague, click invite.')
	    ),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _i18next2.default.t('Share your webcam')
	    ),
	    _react2.default.createElement('img', {
	      src: webcamImgSrc,
	      alt: _i18next2.default.t('Share webcam')
	    }),
	    _react2.default.createElement(
	      'p',
	      null,
	      _i18next2.default.t('To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!')
	    ),
	    _react2.default.createElement(
	      'h6',
	      null,
	      _i18next2.default.t('Share your screen')
	    ),
	    _react2.default.createElement('img', {
	      src: screenImgSrc,
	      alt: _i18next2.default.t('Share screen')
	    }),
	    _react2.default.createElement(
	      'p',
	      null,
	      _i18next2.default.t('By showing your screen, you can share documents and presentations with your attendees.')
	    )
	  );
	};
	
	TestMeetingStep.propTypes = propTypes;
	
	exports.default = TestMeetingStep;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  track: _react.PropTypes.func
	};
	
	var defaultProps = {
	  track: function track() {}
	};
	
	var CalendarStep = function CalendarStep(_ref) {
	  var track = _ref.track;
	
	  var pluginsUrl = 'https://www.gotomeeting.com/features/quick-one-click-meetings';
	  var bucketUrl = 'https://cdn.gotomeet.at/get-set-up';
	  var outlookImg = 'icon-outlook';
	  var googleImg = 'icon-googlecal';
	
	  var outlookImgSrc = bucketUrl + '/' + outlookImg + '.png';
	  var outlookImgSrcSet = bucketUrl + '/' + outlookImg + '-2x.png 2x';
	  var googleImgSrc = bucketUrl + '/' + googleImg + '.png';
	  var googleImgSrcSet = bucketUrl + '/' + googleImg + '-2x.png 2x';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'calendar-step' },
	    _i18next2.default.t('Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.'),
	    _react2.default.createElement(
	      'ul',
	      { className: 'list-unstyled' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('img', { src: outlookImgSrc, alt: '', srcSet: outlookImgSrcSet }),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'inverse togo-font-semibold outlook-plugin',
	            target: '_blank',
	            href: pluginsUrl,
	            onClick: function onClick() {
	              return track('Click GSU Outlook Plugin Link');
	            }
	          },
	          _i18next2.default.t('Outlook Scheduler')
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('img', { src: googleImgSrc, alt: '', srcSet: googleImgSrcSet }),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'inverse togo-font-semibold google-cal-plugin',
	            target: '_blank',
	            href: pluginsUrl,
	            onClick: function onClick() {
	              return track('Click GSU Google Plugin Link');
	            }
	          },
	          _i18next2.default.t('Google Calendar plug-in')
	        )
	      )
	    )
	  );
	};
	
	CalendarStep.propTypes = propTypes;
	CalendarStep.defaultProps = defaultProps;
	
	exports.default = CalendarStep;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var completeStep = function completeStep() {};
	
	var set = function set(callback) {
	  if (typeof callback !== 'function') {
	    throw new Error('Function not provided');
	  }
	
	  completeStep = callback;
	};
	
	var execute = function execute() {
	  completeStep();
	  completeStep = function completeStep() {};
	};
	
	exports.default = { set: set, execute: execute };

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.attach = undefined;
	
	var _indicator = __webpack_require__(56);
	
	var _indicator2 = _interopRequireDefault(_indicator);
	
	var _findTargetElements = __webpack_require__(59);
	
	var _findTargetElements2 = _interopRequireDefault(_findTargetElements);
	
	var _hasCSSAnimationSupport = __webpack_require__(62);
	
	var _hasCSSAnimationSupport2 = _interopRequireDefault(_hasCSSAnimationSupport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var activeIndicatorElements = [];
	var savedActiveStep = void 0;
	
	var detach = function detach() {
	  activeIndicatorElements.forEach(function (activeNode) {
	    return activeNode.parentNode.removeChild(activeNode);
	  });
	  activeIndicatorElements = [];
	};
	
	var attach = function attach(_ref) {
	  var _ref$activeStep = _ref.activeStep,
	      activeStep = _ref$activeStep === undefined ? savedActiveStep : _ref$activeStep,
	      message = _ref.message,
	      isShown = _ref.isShown;
	
	  if ((0, _hasCSSAnimationSupport2.default)()) {
	    if (activeStep) {
	      savedActiveStep = activeStep;
	    }
	
	    detach();
	
	    if (isShown) {
	      activeIndicatorElements = (0, _findTargetElements2.default)({ activeStep: activeStep, message: message }).filter(function (targetElement) {
	        return targetElement;
	      }).map(function (targetElement) {
	        return targetElement.appendChild(_indicator2.default.cloneNode());
	      });
	    }
	  }
	
	  return activeIndicatorElements;
	};
	
	exports.attach = attach;
	exports.default = { attach: attach };

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(57);
	
	var element = document.createElement('span');
	element.className = 'pulsing-indicator';
	
	exports.default = element;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIframeDocuments = __webpack_require__(60);
	
	var _getIframeDocuments2 = _interopRequireDefault(_getIframeDocuments);
	
	var _getActiveId = __webpack_require__(61);
	
	var _getActiveId2 = _interopRequireDefault(_getActiveId);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var activeStep = _ref.activeStep,
	      message = _ref.message;
	
	  var activeIds = (0, _getActiveId2.default)({ activeStep: activeStep, message: message });
	
	  return activeIds.map(function (id) {
	    if (document.getElementById(id)) {
	      return document.getElementById(id);
	    }
	
	    var iframeDocument = (0, _getIframeDocuments2.default)().find(function (contentDocument) {
	      return contentDocument.getElementById(id);
	    });
	    if (iframeDocument) {
	      return iframeDocument.getElementById(id);
	    }
	
	    return undefined;
	  }).filter(function (element) {
	    return element;
	  });
	};

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return [document.getElementsByClassName('scheduler-iframe')[0], document.getElementsByClassName('invite-component-iframe')[0]].filter(function (element) {
	    return element;
	  }).map(function (element) {
	    return element.contentDocument;
	  }).filter(function (contentDocument) {
	    return contentDocument;
	  });
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stepKeys = __webpack_require__(22);
	
	var _stepKeys2 = _interopRequireDefault(_stepKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var activeStep = _ref.activeStep,
	      message = _ref.message;
	
	  var isInviteTextMessage = message === 'inviteModal:clickedTextAction';
	
	  if (!activeStep || _stepKeys2.default.schedule && isInviteTextMessage) {
	    return [];
	  }
	
	  var idRules = {
	    'g2mm-header-link': activeStep === _stepKeys2.default.personalRoom,
	    'schedule-later': activeStep === _stepKeys2.default.schedule && (!message || message === 'scheduleModal:canceled'),
	    'meeting-subject-input-group': activeStep === _stepKeys2.default.schedule && message === 'scheduleModal:shown',
	    'save-button': activeStep === _stepKeys2.default.schedule && message === 'scheduleModal:meetingNameFocused',
	    btnCopyInvite: activeStep === _stepKeys2.default.schedule && message === 'inviteModal:shown',
	    'start-gotomeeting': activeStep === _stepKeys2.default.testMeeting
	  };
	
	  return Object.keys(idRules).filter(function (id) {
	    return idRules[id];
	  });
	};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return 'WebkitTransition' in document.body.style || 'MozTransition' in document.body.style || 'OTransition' in document.body.style || 'transition' in document.body.style;
	};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(68);
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  isWindows: _react.PropTypes.bool
	};
	
	var Footer = function Footer(_ref) {
	  var isWindows = _ref.isWindows;
	
	  var locale = _i18next2.default.language;
	  var trainingUrl = locale.substring(0, 2) === 'de' ? 'https://attendee.gototraining.com/5p6g1/catalog/6625195646583310080' : 'https://student.gototraining.com/5p6g1/catalog/6185640558473054208';
	  var supportUrl = locale.substring(0, 2) === 'en' ? 'https://support.logmeininc.com/gotomeeting' : 'https://support.logmeininc.com/' + locale + '/gotomeeting';
	  var userGuideUrl = 'https://link.gotomeeting.com/plogin-org-user-guide';
	
	  var dangerousHtml = {
	    __html: _i18next2.default.t('There\'s more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s', '<a class="inverse" target="_blank" href="' + trainingUrl + '">', '</a>', ' <a class="inverse" target="_blank" href="' + supportUrl + '">', '</a>')
	  };
	
	  var userGuideTextHtml = {
	    __html: _i18next2.default.t('There\'s more to learn! Sign up for a %sfree training%s or explore our %suser guide%s', '<a class="inverse" target="_blank" href="' + trainingUrl + '">', '</a>', ' <a class="inverse" target="_blank" href="' + userGuideUrl + '">', '</a>')
	  };
	
	  var displayHtml = locale.substring(0, 2) === 'en' && isWindows ? userGuideTextHtml : dangerousHtml;
	
	  return _react2.default.createElement('div', { className: 'side-menu-footer', dangerouslySetInnerHTML: displayHtml });
	};
	
	Footer.propTypes = propTypes;
	exports.default = Footer;

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */,
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = { "de": { "translation": { "Personal Meeting Room": "Persönlicher Meetingraum", "Schedule a Meeting": "Meeting planen", "Explore Audio Options": "Audio-Einstellungen erkunden", "Start a Test Meeting": "Testmeeting starten", "Integrate Calendar": "Kalender integrieren", "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.": "Ihr persönlicher Meetingraum ist eingerichtet und bereit. Wenn Sie kurzfristig ein Meeting starten möchten, teilen Sie den Link für Ihren Meetingraum per E-Mail, Chat oder Kalendereinladung mit Ihren Teilnehmern.", "Let's schedule your first meeting!": "Planung Ihres ersten Meetings", "Click Schedule": "Klicken Sie auf \"Planen\"", "Add a meeting title": "Geben Sie einen Namen für das Meeting ein", "Click Save": "Klicken Sie auf \"Speichern\"", "Copy %s share invitation": "Kopieren und teilen Sie die Einladung", "Learn about different audio features and options available.": "Weitere Informationen zu Audiofunktionen und Einstellungen", "Enjoy two ways to connect": "Zwei Möglichkeiten zum Herstellen einer Verbindung", "Choose between using telephone audio and you computer's microphone and speakers": "Audioverbindung über Telefon oder Mikrofon und Lautsprecher des Computers", "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.": "Sie können entweder das Mikrofon und die Lautsprecher Ihres Computers verwenden oder sich über eine Telefonnummmer mit Ihrem Telefonapparat einwählen.", "Easily dial in": "Einfaches Einwählen", "Dial in using number and PIN": "Einwählen über Telefonnummer und PIN", "Sound your best": "Optimale Audioqualität", "To dial in by phone, call the number in the meeting invitation, and then enter your access code &amp; Audio PIN. %sRecommended if you have a slow internet connection.": "Zur Einwahl per Telefon müssen Sie die Telefonnummer der Meeting-Einladung wählen und dann den Zugriffscode und die Audio-PIN eingeben.%sDiese Methode empfiehlt sich, wenn Sie eine langsame Internetverbindung haben.", "A headset and a good internet connection will keep you and your attendees sounding your best.": "Ein Headset und eine gute Internetverbindung gewährleisten eine optimale Audioqualität.", "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.": "Sie verwenden Outlook oder Google Kalendar? Laden Sie das GoToMeeting-Kalendar-Plug-In herunter und planen Sie Online-Meetings mit einem Klick.", "Google Calendar plug-in": "Google-Kalendar-Plug-In", "Outlook Scheduler": "Outlook Scheduler", "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.": "Machen Sie sich anhand eines Testmeetings mit den Meetingfunktionen vertraut. Wenn Sie Ihr erstes Meeting starten, wird die App heruntergeladen und automatisch gestartet.", "Invite attendees": "Teilnehmer einladen", "Share test meeting": "Zum Testmeeting einladen", "Share your webcam": "Eigene Webcam übertragen", "To share your test meeting with a friend or colleague, click invite.": "Klicken Sie auf \"Einladen\", um Freunde oder Kollegen am Testmeeting zu beteiligen.", "Share webcam": "Webcam übertragen", "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!": "Klicken Sie auf das Kamerasymbol, um Ihre Webcam zu übertragen. Tipp: Meetings mit Webcamübertragungen sind persönlicher und lebendiger!", "Share your screen": "Ihren Bildschirm übertragen", "Share screen": "Bildschirm übertragen", "By showing your screen, you can share documents and presentations with your attendees.": "Mithilfe der Bildschirmübertragung können Sie Ihren Teilnehmern Dokumente und Unterlagen präsentieren.", "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s": "Es gibt noch mehr zu lernen! Melden Sie sich an für eine %skostenlose Schulung%s oder erkunden Sie unsere %sSupport-Website%s" } }, "en": { "translation": { "Personal Meeting Room": "Personal Meeting Room", "Schedule a Meeting": "Schedule a Meeting", "Explore Audio Options": "Explore Audio Options", "Start a Test Meeting": "Start a Test Meeting", "Integrate Calendar": "Integrate Calendar", "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.": "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.", "Let's schedule your first meeting!": "Let's schedule your first meeting!", "Click Schedule": "Click Schedule", "Add a meeting title": "Add a meeting title", "Click Save": "Click Save", "Copy %s share invitation": "Copy %s share invitation", "Learn about different audio features and options available.": "Learn about different audio features and options available.", "Enjoy two ways to connect": "Enjoy two ways to connect", "Choose between using telephone audio and you computer's microphone and speakers": "Choose between using telephone audio and you computer's microphone and speakers", "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.": "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.", "Easily dial in": "Easily dial in", "Dial in using number and PIN": "Dial in using number and PIN", "Sound your best": "Sound your best", "To dial in by phone, call the number in the meeting invitation, and then enter your access code %s Audio PIN. %sRecommended if you have a slow internet connection.": "To dial in by phone, call the number in the meeting invitation, and then enter your access code %s Audio PIN. %sRecommended if you have a slow internet connection.", "A headset and a good internet connection will keep you and your attendees sounding your best.": "A headset and a good internet connection will keep you and your attendees sounding your best.", "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.": "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.", "Google Calendar plug-in": "Google Calendar plug-in", "Outlook Scheduler": "Outlook Scheduler", "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.": "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.", "Invite attendees": "Invite attendees", "Share test meeting": "Share test meeting", "Share your webcam": "Share your webcam", "To share your test meeting with a friend or colleague, click invite.": "To share your test meeting with a friend or colleague, click invite.", "Share webcam": "Share webcam", "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!": "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!", "Share your screen": "Share your screen", "Share screen": "Share screen", "By showing your screen, you can share documents and presentations with your attendees.": "By showing your screen, you can share documents and presentations with your attendees.", "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s": "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s", "There's more to learn! Sign up for a %sfree training%s or explore our %suser guide%s": "There's more to learn! Sign up for a %sfree training%s or explore our %suser guide%s" } }, "es": { "translation": { "Personal Meeting Room": "Sala personal de reuniones", "Schedule a Meeting": "Programar reunión", "Explore Audio Options": "Explorar opciones de audio", "Start a Test Meeting": "Iniciar una reunión de prueba", "Integrate Calendar": "Integrar calendario", "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.": "Su sala personal de reuniones está configurada y lista para compartirla. Para iniciar una reunión rápida en cualquier momento, comparta el enlace de su sala de reuniones con los asistentes mediante una invitación de calendario, chat o correo electrónico.", "Let's schedule your first meeting!": "Programemos la primera reunión.", "Click Schedule": "Haga clic en Programar", "Add a meeting title": "Añadir un título de reunión", "Click Save": "Haga clic en Guardar", "Copy %s share invitation": "Copiar y compartir invitación", "Learn about different audio features and options available.": "Obtenga más información acerca de las diferentes funciones de audio y las opciones disponibles.", "Enjoy two ways to connect": "Disfrute de dos formas de conectar", "Choose between using telephone audio and you computer's microphone and speakers": "Elija entre usar el audio del teléfono o el micrófono y los altavoces de su equipo", "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.": "Utilice el micrófono y los altavoces de su equipo, o use el número telefónico para realizar la llamada desde su teléfono.", "Easily dial in": "Marcado fácil", "Dial in using number and PIN": "Marcar con el número y el PIN", "Sound your best": "Su mejor sonido", "To dial in by phone, call the number in the meeting invitation, and then enter your access code &amp; Audio PIN. %sRecommended if you have a slow internet connection.": "Para marcar por teléfono, llame al número de la invitación de la reunión y después introduzca el código de acceso y el PIN de audio. %sSe recomienda si tiene una conexión lenta a internet.", "A headset and a good internet connection will keep you and your attendees sounding your best.": "Tanto usted como los asistentes obtendrán el mejor sonido si dispone de auriculares con micrófono y una buena conexión a Internet.", "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.": "¿Utiliza Outlook o Google Calendar? Descargue el plugin de calendario de GoToMeeting y programe la reuniones en línea con un solo clic.", "Google Calendar plug-in": "Plugin para Google Calendar", "Outlook Scheduler": "Programador de Outlook", "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.": "Explore las funciones de las reuniones con una reunión de prueba. Al iniciar su primera reunión, la aplicación se descargará y se iniciará automáticamente.", "Invite attendees": "Invitar a asistentes", "Share test meeting": "Compartir reunión de prueba", "Share your webcam": "Compartir cámara web", "To share your test meeting with a friend or colleague, click invite.": "Para compartir su reunión de prueba con un amigo o un compañero, haga clic en Invitar.", "Share webcam": "Compartir cámara Web", "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!": "Para compartir su cámara web, haga clic en el icono de cámara. Consejo: las reuniones con cámaras web son más personales y más animadas.", "Share your screen": "Compartir pantalla", "Share screen": "Compartir pantalla", "By showing your screen, you can share documents and presentations with your attendees.": "Al mostrar su pantalla, puede compartir documentos y presentaciones con sus asistentes.", "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s": "Hay mucho más para aprender. Regístrese en un %scurso gratuito%s o explore nuestro %ssitio web de asistencia%s" } }, "fr": { "translation": { "Personal Meeting Room": "Espace de réunion personnel", "Schedule a Meeting": "Planifier une réunion", "Explore Audio Options": "Explorer les options audio", "Start a Test Meeting": "Démarrer une réunion test", "Integrate Calendar": "Intégrer le calendrier", "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.": "Votre espace de réunion personnel est configuré et prêt à être partagé. Pour démarrer une réunion rapide à tout moment, partagez le lien de votre espace de réunion avec les participants par e-mail, chat ou invite de calendrier.", "Let's schedule your first meeting!": "Planifions votre première réunion !", "Click Schedule": "Cliquez sur Planifier", "Add a meeting title": "Ajoutez un titre pour la réunion", "Click Save": "Cliquez sur Enregistrer", "Copy %s share invitation": "Copiez et partagez l'invitation", "Learn about different audio features and options available.": "Découvrez les différentes fonctionnalités et options audio disponibles.", "Enjoy two ways to connect": "Vous disposez de deux méthodes de connexion", "Choose between using telephone audio and you computer's microphone and speakers": "Choisissez entre votre téléphone et le microphone et les haut-parleurs de votre ordinateur", "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.": "Utilisez le microphone et les haut-parleurs de votre ordinateur ou utilisez le numéro pour appeler sur votre téléphone.", "Easily dial in": "Appel facile", "Dial in using number and PIN": "Appelez à l'aide du numéro et d'un code PIN", "Sound your best": "Qualité audio optimale", "To dial in by phone, call the number in the meeting invitation, and then enter your access code &amp; Audio PIN. %sRecommended if you have a slow internet connection.": "Pour utiliser votre téléphone, appelez le numéro indiqué dans l'invitation à la réunion et entrez votre code d'accès et votre code PIN audio. %sRecommandé si votre connexion Internet est lente.", "A headset and a good internet connection will keep you and your attendees sounding your best.": "Un casque et une bonne connexion Internet vous permettront à vous et à vos participants de bénéficier d'une qualité audio optimale.", "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.": "Vous utilisez Outlook ou Google Agenda ? Téléchargez le plug-in de calendrier GoToMeeting et planifiez des réunions en ligne en un seul clic.", "Google Calendar plug-in": "Plug-in Google Agenda", "Outlook Scheduler": "Planificateur Outlook", "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.": "Explorez les fonctions de réunion avec une réunion test. Lorsque vous démarrez votre première réunion, l’application se télécharge et se lance automatiquement.", "Invite attendees": "Inviter des participants", "Share test meeting": "Partager une réunion test", "Share your webcam": "Partager votre webcam", "To share your test meeting with a friend or colleague, click invite.": "Pour partager votre réunion test avec un ami ou un collègue, cliquez sur Inviter.", "Share webcam": "Partager la webcam", "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!": "Pour partager votre webcam, cliquez sur l’icône de caméra. Astuce : les réunions avec webcams sont plus personnelles et plus animées !", "Share your screen": "Partager votre écran", "Share screen": "Partager écran", "By showing your screen, you can share documents and presentations with your attendees.": "En montrant votre écran, vous pouvez partager des documents et des présentations avec vos participants.", "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s": "Pour en savoir plus, inscrivez-vous à %sune formation gratuite%s ou explorez notre %ssite de support%s" } }, "it": { "translation": { "Personal Meeting Room": "Sala riunioni personale", "Schedule a Meeting": "Pianifica riunione", "Explore Audio Options": "Esplora opzioni audio", "Start a Test Meeting": "Avvia riunione di prova", "Integrate Calendar": "Integra calendario", "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.": "La tua sala riunioni personale è configurata e pronta per essere condivisa. Per avviare una rapida riunione in qualsiasi momento, condividi con i partecipanti il collegamento alla sala riunioni via e-mail, chat o tramite invito del calendario.", "Let's schedule your first meeting!": "Pianifichiamo la tua prima riunione.", "Click Schedule": "Fai clic su Pianifica", "Add a meeting title": "Aggiungi un titolo della riunione", "Click Save": "Fai clic su Salva", "Copy %s share invitation": "Copia e condividi l'invito", "Learn about different audio features and options available.": "Scopri le varie funzionalità e opzioni audio disponibili.", "Enjoy two ways to connect": "Sfrutta i due modi di connessione", "Choose between using telephone audio and you computer's microphone and speakers": "Scegli se utilizzare l'audio del telefono e il microfono e gli altoparlanti del computer", "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.": "Utilizza il microfono e gli altoparlanti del computer oppure il numero per chiamare dal telefono.", "Easily dial in": "Facile chiamata", "Dial in using number and PIN": "Chiama utilizzando numero e PIN", "Sound your best": "Audio ottimale", "To dial in by phone, call the number in the meeting invitation, and then enter your access code &amp; Audio PIN. %sRecommended if you have a slow internet connection.": "Per chiamare con il telefono, utilizza il numero presente nell'invito alla riunione e inserisci il tuo codice di accesso insieme al PIN audio. %sQuesta opzione è consigliata in caso di connessione Internet lenta.", "A headset and a good internet connection will keep you and your attendees sounding your best.": "Una cuffia e una buona connessione Internet aiuteranno te e i partecipanti ad ascoltarvi al meglio.", "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.": "Utilizzi Outlook o Google Calendar? Scarica il plug-in del calendario di GoToMeeting e pianifica le riunioni online con un clic.", "Google Calendar plug-in": "Plug-in di Google Calendar", "Outlook Scheduler": "Pianificazione di Outlook", "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.": "Scopri le funzionalità interne con una riunione di prova. Avviando la tua prima riunione, l'app verrà automaticamente scaricata ed avviata.", "Invite attendees": "Invita partecipanti", "Share test meeting": "Condividi riunione di prova", "Share your webcam": "Condividi la webcam", "To share your test meeting with a friend or colleague, click invite.": "Per condividere la riunione di prova con un amico o un collega, fai clic su Invita.", "Share webcam": "Condividi webcam", "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!": "Per condividere la webcam, fai clic sull'icona della videocamera. Suggerimento: le riunioni con l'utilizzo di webcam sono più personali e divertenti.", "Share your screen": "Condividi lo schermo", "Share screen": "Condividi schermo", "By showing your screen, you can share documents and presentations with your attendees.": "Mostrando il tuo schermo, puoi condividere documenti e presentazioni con i partecipanti.", "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s": "C'è molto altro da imparare. Registrati a una %sformazione gratuita%s oppure scopri il nostro %ssito Web del supporto%s" } }, "zh": { "translation": { "Personal Meeting Room": "个人会议室", "Schedule a Meeting": "安排会议", "Explore Audio Options": "浏览音频选项", "Start a Test Meeting": "启动测试会议", "Integrate Calendar": "集成日历", "Your personal meeting room is set up and ready to share. To start a quick meeting anytime, share your meeting room link with attendees through email, chat, or calendar invite.": "您的个人会议室已设置并且已准备好共享。要随时启动快速会议，请通过电子邮件、聊天工具或日历邀请与与会者共享您的会议室链接。", "Let's schedule your first meeting!": "让我们来安排您的第一次会议吧!", "Click Schedule": "单击“安排”", "Add a meeting title": "添加会议标题", "Click Save": "单击“保存”", "Copy %s share invitation": "复制并共享邀请", "Learn about different audio features and options available.": "了解可用的各种音频功能和选项。", "Enjoy two ways to connect": "尽情使用两种连接方式", "Choose between using telephone audio and you computer's microphone and speakers": "选择使用电话音频或者计算机的麦克风和扬声器", "Use your computer microphone %s speakers, or use the dial-in number to call in on your phone.": "使用计算机的麦克风和扬声器，或者使用电话通过拨入号码拨入。", "Easily dial in": "轻松拨入", "Dial in using number and PIN": "使用电话号码和 PIN 码拨入", "Sound your best": "保持最佳音效", "To dial in by phone, call the number in the meeting invitation, and then enter your access code &amp; Audio PIN. %sRecommended if you have a slow internet connection.": "要通过电话拨入，请拨打会议邀请中的电话号码，然后输入您的访问代码和音频 PIN 码。%s建议在 Internet 连接速度缓慢时使用。", "A headset and a good internet connection will keep you and your attendees sounding your best.": "耳麦和状况良好的 Internet 连接将使您和您的与会者的声音效果保持在最佳状态。", "Using Outlook or Google Calendar? Download the GoToMeeting calendar plug-in and schedule online meetings with one click.": "使用 Outlook 或 Google 日历吗? 一键下载 GoToMeeting 日历插件并安排在线会议。", "Google Calendar plug-in": "Google 日历插件", "Outlook Scheduler": "Outlook 计划程序", "Explore in-meeting features with a test meeting. When you start your first meeting, the app will download and launch automatically.": "利用测试会议探索会议中功能。启动您的第一次会议时，应用程序将自动下载并启动。", "Invite attendees": "邀请与会者", "Share test meeting": "共享测试会议", "Share your webcam": "共享您的摄像头", "To share your test meeting with a friend or colleague, click invite.": "要与朋友或同事共享您的测试会议，请单击“邀请”。", "Share webcam": "共享摄像头", "To share your webcam, click the camera icon. Tip: Meetings with webcams are more personal, and more lively!": "要共享您的摄像头，请单击摄像头图标。提示: 使用摄像头的会议更具个性特色，并且更加生动!", "Share your screen": "共享您的桌面", "Share screen": "共享桌面", "By showing your screen, you can share documents and presentations with your attendees.": "通过显示您的桌面，可以与您的与会者共享文档和演示文稿。", "There's more to learn! Sign up for a %sfree training%s or explore our %ssupport website%s": "要了解更多信息，请注册参加 %s免费培训%s 或者浏览我们的 %s技术支持 Web 站点%s" } } };

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _i18next = __webpack_require__(26);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _i18nextSprintfPostprocessor = __webpack_require__(72);
	
	var _i18nextSprintfPostprocessor2 = _interopRequireDefault(_i18nextSprintfPostprocessor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var language = _ref.language,
	      translations = _ref.translations;
	
	  _i18next2.default.use(_i18nextSprintfPostprocessor2.default).init({
	    lng: language,
	    fallbackLng: 'en',
	    keySeparator: false,
	    nsSeparator: false,
	    resources: translations,
	    overloadTranslationOptionHandler: _i18nextSprintfPostprocessor2.default.overloadTranslationOptionHandler
	  });
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(73).default;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _sprintf = __webpack_require__(74);
	
	exports.default = {
	  name: 'sprintf',
	  type: 'postProcessor',
	
	  process: function process(value, key, options) {
	    if (!options.sprintf) return value;
	
	    if (Object.prototype.toString.apply(options.sprintf) === '[object Array]') {
	      return (0, _sprintf.vsprintf)(value, options.sprintf);
	    } else if (_typeof(options.sprintf) === 'object') {
	      return (0, _sprintf.sprintf)(value, options.sprintf);
	    }
	
	    return value;
	  },
	  overloadTranslationOptionHandler: function overloadTranslationOptionHandler(args) {
	    var values = [];
	
	    for (var i = 1; i < args.length; i++) {
	      values.push(args[i]);
	    }
	
	    return {
	      postProcess: 'sprintf',
	      sprintf: values
	    };
	  }
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sprintf = sprintf;
	exports.vsprintf = vsprintf;
	var re = {
	    not_string: /[^s]/,
	    number: /[diefg]/,
	    json: /[j]/,
	    not_json: /[^j]/,
	    text: /^[^\x25]+/,
	    modulo: /^\x25{2}/,
	    placeholder: /^\x25(?:([1-9]\d*)\$|\(([^\)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijosuxX])/,
	    key: /^([a-z_][a-z_\d]*)/i,
	    key_access: /^\.([a-z_][a-z_\d]*)/i,
	    index_access: /^\[(\d+)\]/,
	    sign: /^[\+\-]/
	};
	
	function sprintf() {
	    var key = arguments[0],
	        cache = sprintf.cache;
	    if (!(cache[key] && cache.hasOwnProperty(key))) {
	        cache[key] = sprintf.parse(key);
	    }
	    return sprintf.format.call(null, cache[key], arguments);
	}
	
	sprintf.format = function (parse_tree, argv) {
	    var cursor = 1,
	        tree_length = parse_tree.length,
	        node_type = "",
	        arg,
	        output = [],
	        i,
	        k,
	        match,
	        pad,
	        pad_character,
	        pad_length,
	        is_positive = true,
	        sign = "";
	    for (i = 0; i < tree_length; i++) {
	        node_type = get_type(parse_tree[i]);
	        if (node_type === "string") {
	            output[output.length] = parse_tree[i];
	        } else if (node_type === "array") {
	            match = parse_tree[i]; // convenience purposes only
	            if (match[2]) {
	                // keyword argument
	                arg = argv[cursor];
	                for (k = 0; k < match[2].length; k++) {
	                    if (!arg.hasOwnProperty(match[2][k])) {
	                        throw new Error(sprintf("[sprintf] property '%s' does not exist", match[2][k]));
	                    }
	                    arg = arg[match[2][k]];
	                }
	            } else if (match[1]) {
	                // positional argument (explicit)
	                arg = argv[match[1]];
	            } else {
	                // positional argument (implicit)
	                arg = argv[cursor++];
	            }
	
	            if (get_type(arg) == "function") {
	                arg = arg();
	            }
	
	            if (re.not_string.test(match[8]) && re.not_json.test(match[8]) && get_type(arg) != "number" && isNaN(arg)) {
	                throw new TypeError(sprintf("[sprintf] expecting number but found %s", get_type(arg)));
	            }
	
	            if (re.number.test(match[8])) {
	                is_positive = arg >= 0;
	            }
	
	            switch (match[8]) {
	                case "b":
	                    arg = arg.toString(2);
	                    break;
	                case "c":
	                    arg = String.fromCharCode(arg);
	                    break;
	                case "d":
	                case "i":
	                    arg = parseInt(arg, 10);
	                    break;
	                case "j":
	                    arg = JSON.stringify(arg, null, match[6] ? parseInt(match[6]) : 0);
	                    break;
	                case "e":
	                    arg = match[7] ? arg.toExponential(match[7]) : arg.toExponential();
	                    break;
	                case "f":
	                    arg = match[7] ? parseFloat(arg).toFixed(match[7]) : parseFloat(arg);
	                    break;
	                case "g":
	                    arg = match[7] ? parseFloat(arg).toPrecision(match[7]) : parseFloat(arg);
	                    break;
	                case "o":
	                    arg = arg.toString(8);
	                    break;
	                case "s":
	                    arg = (arg = String(arg)) && match[7] ? arg.substring(0, match[7]) : arg;
	                    break;
	                case "u":
	                    arg = arg >>> 0;
	                    break;
	                case "x":
	                    arg = arg.toString(16);
	                    break;
	                case "X":
	                    arg = arg.toString(16).toUpperCase();
	                    break;
	            }
	            if (re.json.test(match[8])) {
	                output[output.length] = arg;
	            } else {
	                if (re.number.test(match[8]) && (!is_positive || match[3])) {
	                    sign = is_positive ? "+" : "-";
	                    arg = arg.toString().replace(re.sign, "");
	                } else {
	                    sign = "";
	                }
	                pad_character = match[4] ? match[4] === "0" ? "0" : match[4].charAt(1) : " ";
	                pad_length = match[6] - (sign + arg).length;
	                pad = match[6] ? pad_length > 0 ? str_repeat(pad_character, pad_length) : "" : "";
	                output[output.length] = match[5] ? sign + arg + pad : pad_character === "0" ? sign + pad + arg : pad + sign + arg;
	            }
	        }
	    }
	    return output.join("");
	};
	
	sprintf.cache = {};
	
	sprintf.parse = function (fmt) {
	    var _fmt = fmt,
	        match = [],
	        parse_tree = [],
	        arg_names = 0;
	    while (_fmt) {
	        if ((match = re.text.exec(_fmt)) !== null) {
	            parse_tree[parse_tree.length] = match[0];
	        } else if ((match = re.modulo.exec(_fmt)) !== null) {
	            parse_tree[parse_tree.length] = "%";
	        } else if ((match = re.placeholder.exec(_fmt)) !== null) {
	            if (match[2]) {
	                arg_names |= 1;
	                var field_list = [],
	                    replacement_field = match[2],
	                    field_match = [];
	                if ((field_match = re.key.exec(replacement_field)) !== null) {
	                    field_list[field_list.length] = field_match[1];
	                    while ((replacement_field = replacement_field.substring(field_match[0].length)) !== "") {
	                        if ((field_match = re.key_access.exec(replacement_field)) !== null) {
	                            field_list[field_list.length] = field_match[1];
	                        } else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
	                            field_list[field_list.length] = field_match[1];
	                        } else {
	                            throw new SyntaxError("[sprintf] failed to parse named argument key");
	                        }
	                    }
	                } else {
	                    throw new SyntaxError("[sprintf] failed to parse named argument key");
	                }
	                match[2] = field_list;
	            } else {
	                arg_names |= 2;
	            }
	            if (arg_names === 3) {
	                throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
	            }
	            parse_tree[parse_tree.length] = match;
	        } else {
	            throw new SyntaxError("[sprintf] unexpected placeholder");
	        }
	        _fmt = _fmt.substring(match[0].length);
	    }
	    return parse_tree;
	};
	
	function vsprintf(fmt, argv, _argv) {
	    _argv = (argv || []).slice(0);
	    _argv.splice(0, 0, fmt);
	    return sprintf.apply(null, _argv);
	}
	
	/**
	 * helpers
	 */
	function get_type(variable) {
	    return Object.prototype.toString.call(variable).slice(8, -1).toLowerCase();
	}
	
	function str_repeat(input, multiplier) {
	    return Array(multiplier + 1).join(input);
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stepStates = __webpack_require__(76);
	
	var _stepStates2 = _interopRequireDefault(_stepStates);
	
	var _notify = __webpack_require__(77);
	
	var _notify2 = _interopRequireDefault(_notify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { stepStates: _stepStates2.default, notify: _notify2.default };

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stepKeys = __webpack_require__(22);
	
	var _stepKeys2 = _interopRequireDefault(_stepKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var flags = options.userSettings || {};
	
	  var personalRoom = {
	    key: _stepKeys2.default.personalRoom,
	    isDone: options.hasPersonalRoom
	  };
	
	  var schedule = {
	    key: _stepKeys2.default.schedule,
	    isDone: flags.hasScheduledMeeting
	  };
	
	  var audio = {
	    key: _stepKeys2.default.audio,
	    isDone: flags.hasExploredAudioOptions,
	    complete: function complete() {
	      return options.complete('hasExploredAudioOptions');
	    }
	  };
	
	  var testMeeting = {
	    key: _stepKeys2.default.testMeeting,
	    isDone: flags.hasStartedMeeting
	  };
	
	  var calendar = {
	    key: _stepKeys2.default.calendar,
	    isDone: flags.hasIntegratedCalendar,
	    complete: function complete() {
	      return options.complete('hasIntegratedCalendar');
	    }
	  };
	
	  return [personalRoom, schedule, audio, testMeeting, calendar];
	}; /**
	    * Configures data that consuming apps are familiar with, meetings and flags, to what the React comnponent is familiar with, steps
	    */

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _indicator = __webpack_require__(55);
	
	/**
	 * Call this method when a DOM update occurs that the side menu should be concerned about.
	 */
	exports.default = function (_ref) {
	  var isShown = _ref.isShown,
	      activeStep = _ref.activeStep,
	      message = _ref.message;
	
	  (0, _indicator.attach)({ isShown: isShown, activeStep: activeStep, message: message });
	};

/***/ })
/******/ ])
});
;
//# sourceMappingURL=SideMenu.js.map;
